import React from "react";

const SplitProfileOption = option => {
	const notAvailable = !option?.isAvailable;

	if (!option) {
		return null;
	} else if (option.value && notAvailable) {
		return <i>{option.name} (Inactive)</i>;
	} else {
		return option.name;
	}
};

export default SplitProfileOption;
